import React from 'react';
import {
  FDStack, FDTitleText, FDPaper, FDBodyText, FDIcon,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const CompareColumn = ({
  title, descriptions, descriptionColor, descriptionAppearance, showChecks = false,
}) => {
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDStack paddingX={2}>
        <FDTitleText size={isMobile ? 'sm' : 'md'} value={title} />
      </FDStack>
      {descriptions.map((description) => (
        <FDPaper color={descriptionColor} appearance={descriptionAppearance}>
          <FDStack padding={isMobile ? 1 : 2} spacing={1}>
            {showChecks && <FDIcon icon={'check'} />}
            <FDBodyText size={isMobile ? 'sm' : 'md'} value={description} />
          </FDStack>
        </FDPaper>
      ))}
    </FDStack>
  );
};
